document.addEventListener("DOMContentLoaded", () => {
  class CountdownTimer {
    constructor(timerElement) {
      this.timerElement = timerElement;
      this.timerInit();
    }

    timerInit() {
      if (!this.timerElement) return;

      this.dateAttribute = this.timerElement.getAttribute("data-date");
      this.timeAttribute = this.timerElement.getAttribute("data-time");

      if (this.dateAttribute != undefined && this.dateAttribute != null) {
        const timerDate = this.dateAttribute.split("-");
        this.dataYear = timerDate[0];
        this.dataMonth = timerDate[1];
        this.dataDay = timerDate[2];
      }

      if (this.timeAttribute != undefined && this.timeAttribute != null) {
        const timerTime = this.timeAttribute.split(":");
        this.timeHour = timerTime[0];
        this.timeMinute = timerTime[1];
      }

      this.countDownDate = new Date(
        this.dataYear,
        this.dataMonth - 1,
        this.dataDay,
        this.timeHour,
        this.timeMinute,
        0,
        0
      ).getTime();

      this.startCountdown();
    }

    startCountdown() {
      if (!this.countDownDate) return;

      this.interval = setInterval(() => {
        const now = new Date().getTime();
        const distance = this.countDownDate - now;

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        this.timerElement.querySelector(".days").innerText = days;
        this.timerElement.querySelector(".hours").innerText = hours;
        this.timerElement.querySelector(".minutes").innerText = minutes;
        this.timerElement.querySelector(".seconds").innerText = seconds;

        if (days === 0)
          this.timerElement
            .querySelector(".timer-block-days")
            ?.classList.add("hidden");

        if (this.timerElement.classList.contains("hidden")) {
          this.timerElement.classList.remove("hidden");
        }

        if (distance < 0) {
          clearInterval(this.interval);
          this.timerElement.classList.add("hidden");
        }
      }, 1000);
    }
  }

  const timerWrapper = document.querySelector(
    ".announcement-bar .timer-wrapper"
  );
  const pElement = document.querySelector(
    ".announcement-bar li.announcement-list-item p"
  );

  if (timerWrapper && pElement) {
    pElement.appendChild(timerWrapper);
  }

  const timers = document.querySelectorAll("countdown-timer.timer");
  if (timers.length > 0) {
    timers.forEach((timer) => {
      const newTimer = new CountdownTimer(timer);
    });
  }
});
